export default function auth({ next }) {
  if (!localStorage.getItem("privateToken")) {
    return next({
      name: "Login",
    });
  }

  return next();
}
